import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { guestSource, loadGuestGame, newGuestGame, type GuestGame } from '../game/guest.ts';
import { GameScreen } from '../game/screen/GameScreen.tsx';

/**
 * `/play`: a game against the computer on the small map, open to guests. The browser keeps it
 * (game/guest.ts); a new game from the menu opens the screen afresh.
 */
export function GuestPlay() {
  const { t } = useTranslation();
  const [game, setGame] = useState<GuestGame>(() => loadGuestGame() ?? newGuestGame());
  return <GuestScreen key={game.setup.seed} game={game} onNewGame={setGame} title={t('app.shortName')} />;
}

function GuestScreen({
  game,
  onNewGame,
  title,
}: {
  game: GuestGame;
  onNewGame: (game: GuestGame) => void;
  title: string;
}) {
  // The screen reads its source once: the game as it opens, then the browser's answers.
  const [source] = useState(() => guestSource(game, onNewGame));
  return <GameScreen source={source} title={title} />;
}
